import request from "@/utils/request";

// 测试请求
export function test(data) {
  return request({
    url: "/gateway/ts",
    method: "post",
    data: data,
  });
}
// 问卷类型 字典 列表
export function getTreeClassRoom(flag) {
  return request({
    url: `/base/dict/data/v1/classroom/tree?flag=${ flag ? flag : 1 }`,
    method: "get"
  })
}
// 问卷类型 字典 列表
export function getExamTypes() {
  return request({
    url: "/app/ddxk/questionnaire/type/v1/dict",
    method: "get"
  })
}
// 学院院系 字典 列表
export function getDepartment() {
  return request({
    url: "/base/base/data/v1/college/dict",
    method: "get"
  })
}
// 学期列表 - 字典
export function getSemester() {
  return request({
    url: "/app/ddxk/base/data/v1/calendar/dict",
    method: "get"
  })
}
// 学期列表 - base服务
export function getBaseSemester() {
  return request({
    url: "/base/calendar/v1/list",
    method: "get"
  })
}
// 根据当前日期查询当前时间所属第几周
export function getDateTimeWeek(data) {
  return request({
    url: `/base/calendar/getClendarInWeek?id=${data}`,
    method: "get"
  })
}
// 查询所属校历一共多少周
export function getClendarWeeks(data) {
  return request({
    url: `/base/calendar/getClendarWeeks?id=${data.id}`,
    method: "get"
  })
}
// 简单文件上传  
export function SimpleBaseFileUpload(data) {
  return request({
    url: "/base/tool/file/v1/simple/upload",
    method: "post",
    headers: { "Content-Type": "multipart/form-data" },
    data: data,
  });
}
// 删除文件 
export function delefile(data){
  return request({
    url: `/base/tool/file/v1/delete?fileId=${data}`,
    method: "post",
  })
}
// 判断当前时间所属是第几周
export function getClendarInWeek(data) {
  return request({
    url: `/base/calendar/getClendarInWeek?id=${data.id}`,
    method: "get"
  })
}
// 获取巡课录播全局设置
export function getEqumentDetail() {
  return request({
    url: `/base/recorder/set/v1/getInfoById`,
    method: "get"
  })
}

// 通过userid 获取用户信息
export function getUserInfo(userId) {
  return request({
    url: `/base/user/v1/info?userId=${userId}`,
    method: "get",
  });
}
export function getUserInfoNew(userId) {
  return request({
    url: `/base/system/user/detail?userId=${userId}`,
    method: "get",
  });
}

// 根据code获取学校信息
export function getSchoolInfoCode(code) {
  return request({
    url: `/base/system/tenant/school/hero/get/school/info/by/code?code=${code}`,
    method: "get",
  });
}

// 用户申请绑定学校
export function applyBindSchool(schoolId, userId) {
  return request({
    url: `/base/system/user/user/apply/bind/school?schoolId=${schoolId}&userId=${userId}`,
    method: "post",
  });
}
// 个人信息 修改密码
export function modifyPassword(data) {
  return request({
    url: `/base/user/v1/update/pwd`,
    method: "post",
    data: data,
  });
}

// 修改个人信息
export function updateUserInfo(data) {
  return request({
    url: `/base/user/v1/update/info`,
    method: "post",
    data: data
  });
}

// 根据个人信息头像文件id 获取文件地址
export function getUserfileimg(fileId) {
  return request({
    url: `/base/tool/file/v1/get/info/of/id?fileId=${fileId}`,
    method: "get",
  });
}

// 简单文件上传
export function addBaseFileUpload(data) {
  return request({
    url: "/base/tool/file/v1/simple/upload",
    method: "post",
    headers: { "Content-Type": "multipart/form-data" },
    data: data,
  });
}

// 获取设备信息
export function getEqumentInfo(data) {
  return request({
    url: `/base/device/v1/get/dev/record/status`,
    method: "get",
    params: data,
  });
}
// 获取设备录制状态 -- 天津
export function getEqumentInfoTJ(data) {
  return request({
    url: `/base/device/v1/get/tour/info`,
    method: "get",
    params: data,
  });
}
// 获取设备录制时间 -- 天津
export function getEqumentLZTIME(data) {
  return request({
    url: `/base/device/v1/get/dev/record/time`,
    method: "get",
    params: data,
  });
}


// 获取用户列表 
export function getALLUSERlist(data) {
  return request({
    url: `/base/user/v1/list`,
    method: "post",
    data: data,
  });
}
// 下载课表导入模板
export function downloadFile(data) {
  return request({
    url: `/base/tool/file/v1/download`,
    responseType:'blob',
    method: "get",
    params: data,
  });
}
// 验证当前六地址是否有流
export function isVidedoUrl(data) {
  return request({
    url: `/base/device/v1/getStreamInFo`,
    method: "get",
    params: data,
  });
}
// 录播回放 分片下载资源
export function lbBlackVideo(data){
  return request({
    url: "/base/tool/file/v1/download/part",
    method: "get",
    responseType: "blob"
  })
}

// 下载资源回调接口
export function downloadResourceCallback(data){
  return request({
    url: "/base/video/download/log/v1/save",
    method: "post",
    data: data,
  })
}



// 获取用户授权按钮
export function getRoleButtonByUserId(userId) {
  return request({
    url: `/app/ddxk/role/v1/getRoleButtonByUserId?userId=${userId}`,
    method: "get",
  });
}







// 云台控制 摄像机
export function control_xj(data){
  return request({
    url: `/base/camera/v1/control/cloud/platform`,
    method: "post",
    data: data,
  });
}
// 云台控制 摄像机 灵敏度保存
export function saveSensitivity(data){
  return request({
    url: `/base/camera/v1/save/camera/sensitivity`,
    method: "post",
    data: data,
  });
}
// 云台控制 摄像机 灵敏度查询
export function getSensitivity(data){
  return request({
    url: `/base/camera/v1/get/camera/sensitivity?cameraId=${data}`,
    method: "get"
  });
}

// 获取用户角色名称
export function getRolesByUserId() {
  return request({
    url: `/app/ddxk/role/v1/getRolesByUserId`,
    method: "get",
  });
}
// 获取用户身份 1管理员 0非管理员
export function getuserRole(){
  return request({
    url: "/app/ddxk/role/v1/isAdmin",
    method: "get"
  })
}



// 服务器管理 内外网
export function getExternalInfo(data) {
  return request({
    url: `/base/servermanager/v1/hero/getExternalInfo`,
    method: "get"
  });
}
